import { useGetSettings } from '@ipfabric/api-client/client/model/settings/settings';
import { Card } from '@ipfabric/ui-components/Card/Card';
import { allowLeave } from '@ipfabric/ui-components/LeaveDialog/LeaveDialog';
import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { useFormComposition } from '@ipfabric/ui-components/utils/formSnippets/useFormComposition';
import type { DiscoverySettingsObject } from 'app/features/DiscoverySettingsForms/model/DiscoverySettingsObject';
import { renderQuery } from 'utils/react-query/renderQuery';
import { pickDiscoverySettingsFromGlobalSettings } from '../../utils/pickDiscoverySettingsFromGlobalSettings';
import { WizardNavigationButtons } from './WizardNavigationButtons';
import { WizardPageLoading } from './WizardPageLoading';
import { WizardPageTemplate } from './WizardPageTemplate';
import type { WizardPageProps } from './configWizard.types';
import { cliSettings } from './groups/cliSettings';

export const DiscoveryConfigWizardPage3 = (props: WizardPageProps) => {
  const globalSettingsQuery = useGetSettings();

  return renderQuery({
    query: globalSettingsQuery,
    renderStaleDataOnMount: false,
    pending: () => <WizardPageLoading wizardStepper={props.wizardStepper} />,
    success: (data) => (
      <WizardPage3
        initialData={pickDiscoverySettingsFromGlobalSettings(data)}
        {...props}
      />
    ),
  });
};

const WizardPage3 = (
  props: WizardPageProps & { initialData: DiscoverySettingsObject },
) => {
  const onSubmit = useStableCallback(
    async (model: DiscoverySettingsObject) => await props.onSubmit(model),
  );

  const formComposition = useFormComposition({
    groups: { cliSettings },
    initialModel: props.initialData,
    onSubmit: onSubmit,
  });
  return (
    <WizardPageTemplate
      title='CLI settings'
      formComposition={formComposition}
      {...props}
    >
      {formComposition.renderGroup('cliSettings')}
      <Card>
        <WizardNavigationButtons
          onNext={() => {
            if (formComposition.form.formState.isDirty) {
              formComposition.makeHandleSubmit(() =>
                allowLeave(() => props.onNextStep()),
              )();
            } else {
              props.onNextStep();
            }
          }}
          isLoading={formComposition.form.formState.isSubmitting}
          onPrevious={() => {
            if (formComposition.form.formState.isDirty) {
              formComposition.makeHandleSubmit(() =>
                allowLeave(() => props.onPreviousStep()),
              )();
            } else {
              props.onPreviousStep();
            }
          }}
        />
      </Card>
    </WizardPageTemplate>
  );
};
